import React from 'react';
import { useShepherdTour } from './useShepherdTour';
import { TOUR_DATA } from './tourData';

const MockTour = ({ autoStart = true, onComplete  }) => {
  const { startTour } = useShepherdTour('mocks', TOUR_DATA.mocks.steps, autoStart, onComplete);

  return (
    <>
    {/* <button onClick={startTour} className="btn btn-primary mt-3">
      Start Mock Tour
    </button> */}
    </>
  );
};

export default MockTour;